/**
 * Gift with Purchase (GWP)
 * Runs site-wide. After any add-to-cart, checks if gift should be added.
 * On /cart page, also checks on load and after quantity changes.
 * No page reload needed.
 */
(function () {
  var config = window.gwpConfig;
  if (!config || !config.enabled || !config.productHandle) return;

  var thresholdCents = config.threshold * 100;
  var discountCode = config.discountCode || '';
  var variantId = null;
  var isActing = false;
  var isReady = false;

  // Resolve variant ID immediately (cached after first call)
  $.getJSON('/products/' + config.productHandle + '.js', function (product) {
    if (!product || !product.variants || !product.variants.length) return;
    variantId = product.variants[0].id;
    isReady = true;

    // If on cart page, check immediately
    if (window.location.pathname === '/cart') {
      checkAndAct();
    }
  });

  function checkAndAct() {
    if (!isReady || isActing) return;

    $.getJSON('/cart.js', function (cart) {
      if (!cart || !cart.items) return;

      var cartTotal = 0;
      var giftLineKey = null;

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.variant_id == variantId) {
          giftLineKey = item.key;
        } else {
          cartTotal += item.final_line_price;
        }
      }

      if (cartTotal >= thresholdCents && !giftLineKey) {
        addGift();
      } else if (cartTotal < thresholdCents && giftLineKey) {
        removeGift(giftLineKey);
      }
    });
  }

  function addGift() {
    isActing = true;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: variantId,
        quantity: 1,
        properties: { '_gwp': 'true' }
      },
      success: function () {
        isActing = false;
        if (discountCode) {
          $.get('/discount/' + encodeURIComponent(discountCode));
        }
        // If on cart page, reload to show the gift
        if (window.location.pathname === '/cart') {
          sessionStorage.setItem('gwp_acted', '1');
          location.reload();
        }
      },
      error: function () { isActing = false; }
    });
  }

  function removeGift(lineKey) {
    isActing = true;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: { id: lineKey, quantity: 0 },
      success: function () {
        isActing = false;
        // If on cart page, reload to reflect removal
        if (window.location.pathname === '/cart') {
          sessionStorage.setItem('gwp_acted', '1');
          location.reload();
        }
      },
      error: function () { isActing = false; }
    });
  }

  // Intercept fetch-based add-to-cart calls (product pages use fetch, not $.ajax)
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');

    return originalFetch.apply(this, args).then(function (response) {
      if (!isActing && isReady && url.indexOf('/cart/add') !== -1) {
        setTimeout(checkAndAct, 800);
      }
      return response;
    });
  };

  // Also catch jQuery-based add-to-cart calls (cdesk.js uses $.ajax)
  $(document).ajaxComplete(function (event, xhr, settings) {
    if (!isReady || isActing) return;
    if (settings.url && settings.url.indexOf('/cart/add') !== -1) {
      setTimeout(checkAndAct, 800);
    }
  });

  // Expose for cart.js to call after quantity/remove changes
  window.gwpCartCheck = function () {
    if (!isActing) checkAndAct();
  };

  // On cart page: listen for remove/quantity clicks and re-check after cart updates
  if (window.location.pathname === '/cart') {
    $(document).on('click', 'cart-remove-button a, .quantity__button', function () {
      // Wait for the cart change to complete, then check
      setTimeout(checkAndAct, 1500);
    });
  }
})();
